import * as React from "react";
const SvgAdomik = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Adomik_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F7F7F7",
  rx: 6
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Adomik_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5BE4FF",
  d: "M22 12.054c-.034 5.5-4.496 9.946-9.996 9.946a9.95 9.95 0 0 1-6.672-2.562h1.884v-1.95s.016 0 .025.016l.2.185c.327.267.662.51 1.014.711 1.071.611 2.268.921 3.557.921s2.487-.318 3.558-.92c.46-.26.888-.578 1.265-.939a1 1 0 0 0 .184-.184 7.2 7.2 0 0 0 2.269-5.274 7.2 7.2 0 0 0-1.281-4.127V5.893h1.975a9.8 9.8 0 0 1 1.834 4.094c.033.159.058.326.092.477.025.184.042.36.058.544.026.159.034.326.034.477 0 .184.017.377.017.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#12164E",
  d: "m19.237 5.114-2.026-.025v1.842C15.12 4.754 11.67 3.9 8.23 5.675A6 6 0 0 0 5.65 8.28c-1.582 3.114-1.013 6.262.762 8.372v1.975H4.52a9.94 9.94 0 0 1-2.478-5.634A9 9 0 0 1 2 12.054v-.108c0-.151 0-.302.017-.46.016-.378.05-.738.109-1.09.025-.15.041-.3.083-.443.034-.142.059-.285.1-.418.076-.293.168-.57.26-.846.034-.117.084-.243.126-.36.05-.117.1-.243.15-.36C4.404 4.453 7.92 2 11.996 2a9.93 9.93 0 0 1 7.242 3.114"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Adomik_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Adomik_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 2h20v20H2z"
}))));
export default SvgAdomik;
//# sourceMappingURL=Adomik.js.map